
import { Component, PropSync, Vue } from 'vue-property-decorator'
import { ExpenditureService } from "@/services/timetrack/ExpenditureService"
import Expenditure from "@/types/expenditure/expenditure"

@Component({
  filters: {
    formatCurrency (value: any) {
      return Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR'
      }).format(value)
    }
  },
  components: {
  }
})
export default class ExpenditureList extends Vue {
  @PropSync('trackingId', { type: String }) currentTrackingId!: string;

  private expenditureService = new ExpenditureService()
  private loading = false
  private expenditures: Expenditure[] | null = null

  private headers = [
    { text: this.$t('timetrack.expenditure.quantity'), value: 'quantity', sortable: false },
    { text: this.$t('timetrack.expenditure.position'), value: 'position', sortable: true, align: 'center' },
    { text: this.$t('timetrack.expenditure.positionPrice'), value: 'positionPrice', sortable: false, align: 'center' },
    { text: this.$t('timetrack.expenditure.totalPrice'), value: 'totalPrice', sortable: false, align: 'end' }
  ]

  created () {
    this.fetchExpenditures()
    this.$root.$on('fetchExpenditures', this.fetchExpenditures)
  }

  private fetchExpenditures () {
    if (!this.currentTrackingId) return
    this.loading = true
    this.expenditureService.getExpendituresForTracking(this.currentTrackingId)
      .then((expenditures) => {
        this.expenditures = expenditures
      }).catch((error) => {
        this.$store.dispatch('error/setError', error)
      }).finally(() => {
        this.loading = false
      })
  }

  private handleExpenditureClicked (expenditure: any) {
    this.$emit('expenditureClicked', expenditure)
  }
}
